import { API } from '..';
import { FetchNotificationParams, INotification, INotificationModel } from '../../models';

export const fetchNotificationsApi = (params: FetchNotificationParams) => {
  return new Promise<INotification>((resolve, reject) => {
    API.post('/v1/notification-service/notifications/user-notifications', {
      ...params,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};


export const readNotificationApi = (id: string) => {
  return new Promise<INotification>((resolve, reject) => {
    API.put('/v1/notification-service/notifications/toggle-read', {
      id
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
